// 时间戳转换为日期+时间  2020年09月16日（周四）12:09
export function formatDate (timestamp) {
  var date = new Date(timestamp)
  var YY = date.getFullYear()
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
  // var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  // const weekArr = ['日', '一', '二', '三', '四', '五', '六']
  // let week = weekArr[date.getDay()];
  // let dateArr = [YY,MM,DD,week,hh,mm];
  return `${YY}-${MM}-${DD} ${hh}:${mm}`
}
// 时间戳转换为日期 2020-09-08
export function formatDay (timestamp) {
  var date = new Date(timestamp)
  var YY = date.getFullYear()
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  return `${YY}-${MM}-${DD}`
}
